import Swal from 'sweetalert2';

export const popUpFormMessage = (isSuccess) => {
  const icon = isSuccess ? 'success' : 'error';
  const title = isSuccess ? 'Form Submitted Successfully' : 'Form Could not be processed.';

  Swal.fire({
    icon: icon,
    title: title,
    confirmButtonColor: '#1769aa',
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.reload();
    }
  })
}

export const showMissingFileNotification =() => {
  return Swal.fire({
    title: 'Missing File in Submission',
    text: "You can either continue or go back.",
    icon: 'warning',
    confirmButtonColor: '#1769aa',
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonText: 'Continue',
    cancelButtonText: 'Go Back'
  })
}

let submittingNotification;
export const showSubmittingNotification = () => {
  submittingNotification = Swal.fire({
    title: 'Submitting Form...',
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => { Swal.showLoading(); }
  });
};

export const closeSubmittingNotification = () => {
  if (submittingNotification) {
    submittingNotification.close();
  }
};

export const showTimelinePopup = ({ title, items, getDate, getText, emptyText = "No data available.",}) => {
  if (!Array.isArray(items) || items.length === 0) {
    return Swal.fire({
      title,
      text: emptyText,
      icon: "info",
      confirmButtonColor: "#1769aa",
    });
  }

  const escapeHtml = (s) =>
    String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const html = `
    <div style="max-height:420px; overflow:auto; text-align:left; padding-right:6px;">
      ${items
        .map((it) => {
          const d = escapeHtml(getDate(it));
          const t = escapeHtml(getText(it));
          return `
            <div style="padding:10px 0; border-bottom:1px solid #e6e6e6;">
              <div style="font-size:12px; color:#667; margin-bottom:4px;">${d}</div>
              <div style="font-size:14px; color:#111;">${t}</div>
            </div>
          `;
        })
        .join("")}
    </div>
  `;

  return Swal.fire({ title, html, width: 800, confirmButtonText: "Close", confirmButtonColor: "#1769aa", });
};

